import * as angular from "angular";
import {ViewSettingsHolderType, ViewSettingsModel, ViewSettingsType} from "../models/view-settings.model";
import {IPromise} from "angular";
import {BringozArray} from "../../persistence-layer/bringoz-array";
import {$viewSettingsFactory} from "../$viewSettings.factory";

export class ViewSettingsRequestsService {

  private $viewSettingsRef: BringozArray<ViewSettingsModel>

  /* @ngInject */
  constructor(private ViewSettingsAPI, private $viewSettings: $viewSettingsFactory) {
    this.$viewSettingsRef = this.$viewSettings();
  }

  // ******************************
  //        Public methods
  // ******************************

  get(pageName: string, settingsTypes?: ViewSettingsType[]): IPromise<ViewSettingsModel[]> {
    const api = this.ViewSettingsAPI.actions.get;
    return this.$$call(api, {
      pageName: pageName,
      settingsTypes: settingsTypes
    }, {}, {}) as IPromise<ViewSettingsModel[]>;
  }

  getByUser(pageName: string, settingsTypes?: string): IPromise<ViewSettingsModel[]> {
    const api = this.ViewSettingsAPI.actions.get;
    return this.$$call(api, {
      holderType: ViewSettingsHolderType.User,
      pageName: pageName,
      settingsTypes: settingsTypes
    }, {}, {}) as IPromise<ViewSettingsModel[]>;
  }

  getBySite(pageName: string, settingsTypes?: string): IPromise<ViewSettingsModel[]> {
    const api = this.ViewSettingsAPI.actions.get;
    return this.$$call(api, {
      holderType: ViewSettingsHolderType.Site,
      pageName: pageName,
      settingsTypes: settingsTypes
    }, {}, {}) as IPromise<ViewSettingsModel[]>;
  }

  createByUser(viewSettings: ViewSettingsModel): IPromise<ViewSettingsModel> {
    const api = this.ViewSettingsAPI.actions.create;
    return this.$$call(api, {}, viewSettings, {});
  }

  updateByUser(settingsId: string, viewSettings: ViewSettingsModel): IPromise<ViewSettingsModel> {
    const api = this.ViewSettingsAPI.actions.update;
    return this.$$call(api, {}, viewSettings, {settingsId: settingsId});
  }

  deleteByUser(settingsId: string): IPromise<any> {
    const api = this.ViewSettingsAPI.actions.delete;
    return this.$$call(api, {}, {}, {settingsId: settingsId});
  }

  // ******************************
  //        Private methods
  // ******************************


  $$call(_apiCall, _params, _data, _options) {
    return this.$viewSettingsRef.$call(_apiCall, _params, _data, _options);
  }
}

angular
  .module('bringoz.admin.commons')
  .service('viewSettingsRequestsService', ViewSettingsRequestsService);
